<!--notice the <g> nodes has template duplication in this implementation. this is because if we use ng-template and code-reuse
the icons do not work on chrome. This is due to the way angular renders the template and the way chrome analyzes it.
as a result, the <g> nodes only work up to 2 levels -->

<svg xmlns="http://www.w3.org/2000/svg">
	<defs>
		<symbol id="{{iconId}}" #symbol>
			<ng-container *ngFor="let node of nodes" [ngSwitch]="node.type">
<!--				<ng-container *ngTemplateOutlet="geoTemolate;context:{node: node};"></ng-container>-->
				<ng-container [ngSwitch]="node.type">
					<circle *ngSwitchCase="svgIconGraphicsTypes.circle"
							[attr.class]="node.attributes.class"
							[attr.cx]="node.attributes.cx"
							[attr.cy]="node.attributes.cy"
							[attr.r]="node.attributes.r"
							[attr.stroke]="node.attributes.stroke"
							[attr.stroke-width]="node.attributes.strokewidth"
							[attr.fill]="node.attributes.fill">
					</circle>
					<ellipse *ngSwitchCase="svgIconGraphicsTypes.ellipse"
							 [attr.class]="node.attributes.class"
							 [attr.cx]="node.attributes.cx"
							 [attr.cy]="node.attributes.cy"
							 [attr.rx]="node.attributes.rx"
							 [attr.ry]="node.attributes.ry"
							 [attr.fill]="node.attributes.fill">
					</ellipse>
					<line *ngSwitchCase="svgIconGraphicsTypes.line"
						  [attr.class]="node.attributes.class"
						  [attr.x1]="node.attributes.x1"
						  [attr.y1]="node.attributes.y1"
						  [attr.x2]="node.attributes.x2"
						  [attr.y2]="node.attributes.y2"
						  [attr.stroke-linecap]="node.attributes.stroke-linecap"
						  [attr.stroke-linejoin]="node.attributes.stroke-linejoin"
						  [attr.stroke-width]="node.attributes.stroke-width"
						  [attr.fill]="node.attributes.fill"
						  [attr.stroke]="node.attributes.stroke">
					</line>
					<path *ngSwitchCase="svgIconGraphicsTypes.path"
						  [attr.class]="node.attributes.class"
						  [attr.d]="node.attributes.d"
						  [attr.fill]="node.attributes.fill"
						  [attr.stroke]="node.attributes.stroke">
					</path>
					<polygon *ngSwitchCase="svgIconGraphicsTypes.polygon"
							 [attr.class]="node.attributes.class"
							 [attr.fill]="node.attributes.fill"
							 [attr.points]="node.attributes.points">
					</polygon>
					<polyline *ngSwitchCase="svgIconGraphicsTypes.polyline"
							  [attr.class]="node.attributes.class"
							  [attr.points]="node.attributes.points"
							  [attr.fill]="node.attributes.fill">
					</polyline>
					<rect *ngSwitchCase="svgIconGraphicsTypes.rect"
						  [attr.class]="node.attributes.class"
						  [attr.x]="node.attributes.x"
						  [attr.y]="node.attributes.y"
						  [attr.width]="node.attributes.width"
						  [attr.height]="node.attributes.height"
						  [attr.rx]="node.attributes.rx"
						  [attr.ry]="node.attributes.ry"
						  [attr.fill]="node.attributes.fill">
					</rect>
					<g *ngSwitchCase="svgIconGraphicsTypes.g">
						<ng-container *ngFor="let firstSubNode of node.subNodes">
							<ng-container [ngSwitch]="firstSubNode.type">
								<circle *ngSwitchCase="svgIconGraphicsTypes.circle"
										[attr.class]="firstSubNode.attributes.class"
										[attr.cx]="firstSubNode.attributes.cx"
										[attr.cy]="firstSubNode.attributes.cy"
										[attr.r]="firstSubNode.attributes.r"
										[attr.stroke]="firstSubNode.attributes.stroke"
										[attr.stroke-width]="firstSubNode.attributes.strokewidth"
										[attr.fill]="firstSubNode.attributes.fill">
								</circle>
								<ellipse *ngSwitchCase="svgIconGraphicsTypes.ellipse"
										 [attr.class]="firstSubNode.attributes.class"
										 [attr.cx]="firstSubNode.attributes.cx"
										 [attr.cy]="firstSubNode.attributes.cy"
										 [attr.rx]="firstSubNode.attributes.rx"
										 [attr.ry]="firstSubNode.attributes.ry"
										 [attr.fill]="firstSubNode.attributes.fill">
								</ellipse>
								<line *ngSwitchCase="svgIconGraphicsTypes.line"
									  [attr.class]="firstSubNode.attributes.class"
									  [attr.x1]="firstSubNode.attributes.x1"
									  [attr.y1]="firstSubNode.attributes.y1"
									  [attr.x2]="firstSubNode.attributes.x2"
									  [attr.y2]="firstSubNode.attributes.y2"
									  [attr.stroke-linecap]="firstSubNode.attributes.stroke-linecap"
									  [attr.stroke-linejoin]="firstSubNode.attributes.stroke-linejoin"
									  [attr.stroke-width]="firstSubNode.attributes.stroke-width"
									  [attr.fill]="firstSubNode.attributes.fill"
									  [attr.stroke]="firstSubNode.attributes.stroke">
								</line>
								<path *ngSwitchCase="svgIconGraphicsTypes.path"
									  [attr.class]="firstSubNode.attributes.class"
									  [attr.d]="firstSubNode.attributes.d"
									  [attr.fill]="firstSubNode.attributes.fill"
									  [attr.stroke]="firstSubNode.attributes.stroke">
								</path>
								<polygon *ngSwitchCase="svgIconGraphicsTypes.polygon"
										 [attr.class]="firstSubNode.attributes.class"
										 [attr.fill]="firstSubNode.attributes.fill"
										 [attr.points]="firstSubNode.attributes.points">
								</polygon>
								<polyline *ngSwitchCase="svgIconGraphicsTypes.polyline"
										  [attr.class]="firstSubNode.attributes.class"
										  [attr.points]="firstSubNode.attributes.points"
										  [attr.fill]="firstSubNode.attributes.fill">
								</polyline>
								<rect *ngSwitchCase="svgIconGraphicsTypes.rect"
									  [attr.class]="firstSubNode.attributes.class"
									  [attr.x]="firstSubNode.attributes.x"
									  [attr.y]="firstSubNode.attributes.y"
									  [attr.width]="firstSubNode.attributes.width"
									  [attr.height]="firstSubNode.attributes.height"
									  [attr.rx]="firstSubNode.attributes.rx"
									  [attr.ry]="node.attributes.ry"
									  [attr.fill]="firstSubNode.attributes.fill">
								</rect>
								<g *ngSwitchCase="svgIconGraphicsTypes.g">
									<ng-container *ngFor="let subNode of firstSubNode.subNodes">
										<ng-container [ngSwitch]="subNode.type">
											<circle *ngSwitchCase="svgIconGraphicsTypes.circle"
													[attr.class]="subNode.attributes.class"
													[attr.cx]="subNode.attributes.cx"
													[attr.cy]="subNode.attributes.cy"
													[attr.r]="subNode.attributes.r"
													[attr.stroke]="subNode.attributes.stroke"
													[attr.stroke-width]="subNode.attributes.strokewidth"
													[attr.fill]="subNode.attributes.fill">
											</circle>
											<ellipse *ngSwitchCase="svgIconGraphicsTypes.ellipse"
													 [attr.class]="subNode.attributes.class"
													 [attr.cx]="subNode.attributes.cx"
													 [attr.cy]="subNode.attributes.cy"
													 [attr.rx]="subNode.attributes.rx"
													 [attr.ry]="subNode.attributes.ry"
													 [attr.fill]="subNode.attributes.fill">
											</ellipse>
											<line *ngSwitchCase="svgIconGraphicsTypes.line"
												  [attr.class]="subNode.attributes.class"
												  [attr.x1]="subNode.attributes.x1"
												  [attr.y1]="subNode.attributes.y1"
												  [attr.x2]="subNode.attributes.x2"
												  [attr.y2]="subNode.attributes.y2"
												  [attr.stroke-linecap]="subNode.attributes.stroke-linecap"
												  [attr.stroke-linejoin]="subNode.attributes.stroke-linejoin"
												  [attr.stroke-width]="subNode.attributes.stroke-width"
												  [attr.fill]="subNode.attributes.fill"
												  [attr.stroke]="subNode.attributes.stroke">
											</line>
											<path *ngSwitchCase="svgIconGraphicsTypes.path"
												  [attr.class]="subNode.attributes.class"
												  [attr.d]="subNode.attributes.d"
												  [attr.fill]="subNode.attributes.fill"
												  [attr.stroke]="subNode.attributes.stroke">
											</path>
											<polygon *ngSwitchCase="svgIconGraphicsTypes.polygon"
													 [attr.class]="subNode.attributes.class"
													 [attr.fill]="subNode.attributes.fill"
													 [attr.points]="subNode.attributes.points">
											</polygon>
											<polyline *ngSwitchCase="svgIconGraphicsTypes.polyline"
													  [attr.class]="subNode.attributes.class"
													  [attr.points]="subNode.attributes.points"
													  [attr.fill]="subNode.attributes.fill">
											</polyline>
											<rect *ngSwitchCase="svgIconGraphicsTypes.rect"
												  [attr.class]="subNode.attributes.class"
												  [attr.x]="subNode.attributes.x"
												  [attr.y]="subNode.attributes.y"
												  [attr.width]="subNode.attributes.width"
												  [attr.height]="subNode.attributes.height"
												  [attr.rx]="subNode.attributes.rx"
												  [attr.ry]="node.attributes.ry"
												  [attr.fill]="subNode.attributes.fill">
											</rect>
										</ng-container>
									</ng-container>
								</g>
							</ng-container>
						</ng-container>
					</g>
				</ng-container>
			</ng-container>
		</symbol>
	</defs>
</svg>

